import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

import ArticleCard from '../ArticleCard'
import BlockTitle from '../BlockTitle'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const Cards = styled(motion.div)`
  width: 100%;
  margin-inline: auto;
  max-width: calc(100% - ${pxToRem(16)} * 2);

  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const _ArticleCard = styled(motion.create(ArticleCard))`
  border-block-start: 1px solid rgba(0, 0, 0, 0.25);
  padding-block: ${pxToRem(24)};
  transition: border-color 0.6s ease;
  &:last-child {
    border-block-end: 1px solid rgba(0, 0, 0, 0.25);
  }
  @media ${mq(sizes.desktop)} {
    padding-block: ${pxToRem(40)};
  }

  @media (hover: hover) {
    &:hover {
      border-color: ${({ theme }) => theme.colors.black};
    }

    &:first-child:hover ~ & {
      border-top-color: ${({ theme }) => theme.colors.black};
    }
  }
`
